module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.hashrate'
      }
    }
  }, [_vm._v("Hashrate")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.work'
      }
    }
  }, [_vm._v("Total work")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.retarget'
      }
    }
  }, [_vm._v("Retarget")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.speed'
      }
    }
  }, [_vm._v("Speed")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.difficulty'
      }
    }
  }, [_vm._v("Difficulty")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1c8293","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pow.vue
// module id = 554
// module chunks = 1